import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedDocumentReferencesService } from '@app/shared/services/shared-document-references.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class DocumentReferencesDMEPOSService extends SharedDocumentReferencesService {
  constructor(
    http: HttpClient,
    shellService: ShellService
  ) {
    super(http, shellService, ProductNames.DMEPOS)
  }
}
